import React from "react";
import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { CurrencyInputField } from "components/form";
import { QuoteFormValues } from "../../../types";

export const CommonSection = () => {
  const { control } = useFormContext<QuoteFormValues>();

  return (
    <Box className="quoteSection">
      <Typography variant="h6" component="span">
        Details
      </Typography>

      <Box className="quoteCommonFields">
        <CurrencyInputField control={control} label="Down Payment" name="downPayment" />
        <Box />
        <Box />
        <Box />
        <Box />
      </Box>
    </Box>
  );
};
